import {
  Typography,
  Avatar,
  List,
  ListItemAvatar,
  ListItemText,
  Paper,
  makeStyles,
} from "@material-ui/core";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import { ContactSupport } from "@material-ui/icons";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { PublicEnquiriesState } from "../../domain/PublicEnquiry";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { cachedContactTypeService, categoryService } from "../../services";
import { Error, AccessTime } from "@material-ui/icons";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
}));

export const ItemsList: React.FC<{
  state: ItemsState;
  dashboardRedirectUrl?: boolean;
}> = ({ state, dashboardRedirectUrl }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    dashboardRedirectUrl !== true
      ? history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search })
      : history.push(`${pathname}/list/${id}`, { [SEARCH_STATE_KEY]: search });

  const [contactMethodLookups, categoryLookups] = useLookup(
    {
      service: cachedContactTypeService,
      id: "id",
      label: "label",
    },
    categoryService
  );

  return (
    <Paper>
      <List disablePadding>
        {response.data.map((item) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => navigate(item.id)}
              divider
              className={classes.active}
              data-test="row"
              Icon={ContactSupport}
              reference={item.referenceNumber}
              primaryText={`${item.title}`}
              secondaryDetails={[
                {
                  heading: "Created",
                  value: `${formatUtcDate(
                    item.createdDate,
                    standardDateFormats.DATE_TIME
                  )} (${
                    contactMethodLookups.find(
                      (x) => x.id === item.contactMethod
                    )?.label ?? "Unknown"
                  })`,
                },
                {
                  heading: "Received",
                  value: `${formatUtcDate(
                    item.dateReceived,
                    standardDateFormats.DATE
                  )}`,
                },
                {
                  heading: "Category",
                  value: !!item.category
                    ? categoryLookups.find((x) => x.id === item.category)
                        ?.label ?? "Unknown"
                    : "Unknown",
                },
                {
                  heading: "Case lead",
                  value: item.assignedToDisplayName,
                },
              ]}
              chipTexts={[
                {
                  text: `${
                    item.slA_DueDate === null
                      ? `Responded on: ${formatUtcDate(
                          item.slA_ResponseDate,
                          standardDateFormats.DATE
                        )}`
                      : `Response due by:  ${formatUtcDate(
                          item.slA_DueDate,
                          standardDateFormats.DATE
                        )}`
                  }`,
                  icon:
                    item.slA_DueDate &&
                    new Date(item.slA_DueDate) < new Date() &&
                    new Date(item.slA_DueDate).toDateString() !==
                      new Date().toDateString() ? (
                      <Error />
                    ) : item.slA_DueDate &&
                      new Date(item.slA_DueDate).toDateString() ===
                        new Date().toDateString() ? (
                      <AccessTime />
                    ) : null,
                  colour:
                    item.slA_DueDate &&
                    new Date(item.slA_DueDate) < new Date() &&
                    new Date(item.slA_DueDate).toDateString() !==
                      new Date().toDateString()
                      ? "#cd5c5c"
                      : null,
                },
                {
                  text: `Status: ${PublicEnquiriesState(item.status)}`,
                },
              ]}
            >
              <ListItemAvatar>
                <Avatar />
              </ListItemAvatar>
              <ListItemText
                primary={<span>{item.title}</span>}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="textPrimary"
                    ></Typography>
                    <br />
                  </React.Fragment>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};
